import { render } from "./AardVanDePlechtigheidView.vue?vue&type=template&id=2b848f94"
import script from "./AardVanDePlechtigheidView.vue?vue&type=script&lang=js"
export * from "./AardVanDePlechtigheidView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__